// extracted by mini-css-extract-plugin
export default {"root":"breadcrumbs_root__3iFaJ","separator":"breadcrumbs_separator__xt1q4"};